import WaCard from "@awesome.me/webawesome-pro/dist/react/card/index.js";
import WaDetails from "@awesome.me/webawesome-pro/dist/react/details/index.js";
import WaIcon from "@awesome.me/webawesome-pro/dist/react/icon/index.js";
import React from "react";

type Props = {
  isMobile: boolean;
  children: React.ReactNode; // <EstimateNotice />
  className?: string;
};

export const HowFaresAreCalculatedNotice: React.FC<Props> = ({ isMobile, children, className }) => {
  if (!isMobile)
    return (
      <WaCard className={["wa-p-m", "wa-stack", className].filter(Boolean).join(" ")}>
        {children}
      </WaCard>
    );

  return (
    <WaDetails>
      <span
        slot="summary"
        className="wa-cluster wa-gap-2xs wa-heading-s"
        style={{ alignItems: "center" }}
      >
        <WaIcon name="circle-info" style={{ fontSize: "16px" }} />
        <span>How fares are calculated</span>
      </span>

      {children}
    </WaDetails>
  );
};
